/**
 * A `responseType: 'blob'` request's error body arrives as a Blob, which
 * `extractApiError` cannot read — so the server's real message was replaced by
 * a generic status line ("That request wasn't accepted. Check the form…").
 * Decode a JSON error Blob back into an object first:
 *
 *   toast.error(extractApiError(await withJsonErrorBody(err)).message)
 *
 * Kept import-free so it is unit-testable under node:test.
 */
export async function withJsonErrorBody(err) {
  const data = err?.response?.data
  if (typeof Blob !== 'undefined' && data instanceof Blob && /json/i.test(data.type)) {
    try {
      err.response.data = JSON.parse(await data.text())
    } catch {
      // Not parseable — leave the Blob; extractApiError falls back by status.
    }
  }
  return err
}
